// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vp-modal-content {
    padding: 0;
    background: var(--color-component-background, #fff);
    border-radius: 8px;
    overflow: hidden;
}

.vp-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.vp-body-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    background-color: #60a9ef88;
    border: solid 3px #60a9ef;
    border-radius: 6px;
    flex: 1 1 auto;
}

.vp-footer {
    flex: 0 1 auto;
}

/* The wrapper now receives the computed width + height */
.vp-preview-wrapper {
    flex: 1 1 auto;
    height: 100%; /* or a computed px height */
    width: 100%;
    position: relative;
    overflow: hidden; /* important */
}

.vp-in-image-controls {
    display: flex;
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
    gap: 0.5rem;
}

.vp-placeholder {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    z-index: 2;
}

.vp-video-container {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 1rem;
    height: 100%;
}

.vp-video {
    max-width: 30rem;
    max-height: 40vh;
    width: 100%;
}

.vp-controls {
    margin-top: 1rem;
    height: 3rem;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 1rem;
}

    .vp-controls button {
        padding: 0.5rem 1rem;
        border-radius: 4px;
        cursor: pointer;
    }

.vp-progress-container {
    flex: 0 1 auto;
    position: relative;
    height: 1rem;
    margin: 0rem 3rem 1rem 3rem;
    overflow: visible;
}

    .vp-progress-container > .video-time-indicators {
        height: unset;
    }

.vp-progress-bar {
    position: relative;
    width: 100%;
    height: 0.25rem;
    margin-top: 0.125rem;
    background-color: gray;
    overflow: visible;
}

.vp-progress-fill {
    background-color: red;
    height: 100%;
    transition: width 0.1s linear;
}

.vp-progress-ball {
    position: absolute;
    height: 0.8rem;
    width: 0.8rem;
    background-color: red;
    border-radius: 50%;
    transform: translateY(-0.5rem);
    transition: left 0.1s linear;
}

    .vp-progress-ball > div {
        position: relative;
    }

        .vp-progress-ball > div > span {
            position: absolute;
            transform: translate(-50%, 0.75rem);
        }
`, "",{"version":3,"sources":["webpack://./src/Controls/css/VideoPreview.css"],"names":[],"mappings":"AAEA;IACI,UAAU;IACV,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,yDAAyD;AACzD;IACI,cAAc;IACd,YAAY,EAAE,4BAA4B;IAC1C,WAAW;IACX,kBAAkB;IAClB,gBAAgB,EAAE,cAAc;AACpC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;IAEI;QACI,oBAAoB;QACpB,kBAAkB;QAClB,eAAe;IACnB;;AAEJ;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;AACrB;;IAEI;QACI,aAAa;IACjB;;AAEJ;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,4BAA4B;AAChC;;IAEI;QACI,kBAAkB;IACtB;;QAEI;YACI,kBAAkB;YAClB,mCAAmC;QACvC","sourcesContent":["@import '../../css/App.css';\r\n\r\n.vp-modal-content {\r\n    padding: 0;\r\n    background: var(--color-component-background, #fff);\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n}\r\n\r\n.vp-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 1rem;\r\n    margin: 0 auto;\r\n    overflow: hidden;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.vp-body-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    min-height: 0;\r\n    background-color: #60a9ef88;\r\n    border: solid 3px #60a9ef;\r\n    border-radius: 6px;\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.vp-footer {\r\n    flex: 0 1 auto;\r\n}\r\n\r\n/* The wrapper now receives the computed width + height */\r\n.vp-preview-wrapper {\r\n    flex: 1 1 auto;\r\n    height: 100%; /* or a computed px height */\r\n    width: 100%;\r\n    position: relative;\r\n    overflow: hidden; /* important */\r\n}\r\n\r\n.vp-in-image-controls {\r\n    display: flex;\r\n    position: absolute;\r\n    right: 0.5rem;\r\n    top: 0.5rem;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.vp-placeholder {\r\n    position: absolute;\r\n    inset: 0;\r\n    background: rgba(255, 255, 255, 0.65);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 6px;\r\n    z-index: 2;\r\n}\r\n\r\n.vp-video-container {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 1rem;\r\n    height: 100%;\r\n}\r\n\r\n.vp-video {\r\n    max-width: 30rem;\r\n    max-height: 40vh;\r\n    width: 100%;\r\n}\r\n\r\n.vp-controls {\r\n    margin-top: 1rem;\r\n    height: 3rem;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 1rem;\r\n}\r\n\r\n    .vp-controls button {\r\n        padding: 0.5rem 1rem;\r\n        border-radius: 4px;\r\n        cursor: pointer;\r\n    }\r\n\r\n.vp-progress-container {\r\n    flex: 0 1 auto;\r\n    position: relative;\r\n    height: 1rem;\r\n    margin: 0rem 3rem 1rem 3rem;\r\n    overflow: visible;\r\n}\r\n\r\n    .vp-progress-container > .video-time-indicators {\r\n        height: unset;\r\n    }\r\n\r\n.vp-progress-bar {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 0.25rem;\r\n    margin-top: 0.125rem;\r\n    background-color: gray;\r\n    overflow: visible;\r\n}\r\n\r\n.vp-progress-fill {\r\n    background-color: red;\r\n    height: 100%;\r\n    transition: width 0.1s linear;\r\n}\r\n\r\n.vp-progress-ball {\r\n    position: absolute;\r\n    height: 0.8rem;\r\n    width: 0.8rem;\r\n    background-color: red;\r\n    border-radius: 50%;\r\n    transform: translateY(-0.5rem);\r\n    transition: left 0.1s linear;\r\n}\r\n\r\n    .vp-progress-ball > div {\r\n        position: relative;\r\n    }\r\n\r\n        .vp-progress-ball > div > span {\r\n            position: absolute;\r\n            transform: translate(-50%, 0.75rem);\r\n        }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
